document.addEventListener('DOMContentLoaded', function () {
  const swatchTabs = document.querySelectorAll('.swatch-tab-btn');
  const swatchDisplay = document.querySelector('.swatch-display');
  const swatchTabElement = document.querySelector('.swatch-tab');
  const mainContent = document.querySelector('#MainContent');

  mainContent.appendChild(swatchTabElement);

  function getVisibleProductLimit() {
    const width = window.innerWidth;
    if (width < 1024) return 4;
    if (width < 1440) return 6;
    return 8;
  }

  function trimInitialTemplatesToLimit() {
    const limit = getVisibleProductLimit();
    const swatchItems = Array.from(
      swatchDisplay.querySelectorAll('.swatch-item-template')
    );
    if (swatchItems.length > limit) {
      swatchItems.slice(limit).forEach(item => item.remove());
    }
  }
  trimInitialTemplatesToLimit();

  function generateImageVariants(baseImageUrl) {
    return {
      mob: baseImageUrl,
      mob2x: baseImageUrl.replace(/width=\d+/, 'width=334'),
      md: baseImageUrl.replace(/width=\d+/, 'width=300'),
      md2x: baseImageUrl.replace(/width=\d+/, 'width=600'),
      lg: baseImageUrl.replace(/width=\d+/, 'width=324'),
      lg2x: baseImageUrl.replace(/width=\d+/, 'width=648')
    };
  }

  function updateSwatchDisplay(productDataList) {
    const limit = getVisibleProductLimit();
    const visibleProducts = productDataList.slice(0, limit);
    const swatchItems = swatchDisplay.querySelectorAll('.swatch-item-template');

    visibleProducts.forEach((fields, index) => {
      const [title, color, imageUrl, badge, badgeBg, badgeColor] = fields;
      const item = swatchItems[index];
      if (!item) return;

      const imageVariants = generateImageVariants(imageUrl);
      const sources = item.querySelectorAll('source');
      const img = item.querySelector('img');
      const titleElement = item.querySelector('.product-title');
      const colorElement = item.querySelector('.product-color');
      const badgeElement = item.querySelector('.product-badge');

      if (sources[0])
        sources[0].srcset = `${imageVariants.lg}, ${imageVariants.lg2x} 2x`;
      if (sources[1])
        sources[1].srcset = `${imageVariants.md}, ${imageVariants.md2x} 2x`;
      if (img) {
        img.srcset = `${imageVariants.mob}, ${imageVariants.mob2x} 2x`;
        img.alt = title;
      }
      if (titleElement) titleElement.textContent = title;
      if (colorElement) colorElement.textContent = color;
      if (badgeElement) {
        // Clear first: tiles are reused across tabs, so a badge without its own
        // colours would otherwise inherit the previous tab's.
        badgeElement.style.removeProperty('background-color');
        badgeElement.style.removeProperty('color');

        if (badge?.trim()) {
          badgeElement.textContent = badge;
          badgeElement.classList.remove('tw-bg-transparent');
          badgeElement.classList.add('tw-bg-white');
          if (badgeBg?.trim()) {
            badgeElement.style.setProperty('background-color', badgeBg.trim());
          }
          if (badgeColor?.trim()) {
            badgeElement.style.setProperty('color', badgeColor.trim());
          }
        } else {
          badgeElement.textContent = '';
          badgeElement.classList.remove('tw-bg-white');
          badgeElement.classList.add('tw-bg-transparent');
        }
      }

      item.style.display = '';
    });

    for (let i = visibleProducts.length; i < swatchItems.length; i++) {
      swatchItems[i].style.display = 'none';
    }
  }

  const revealSwatchTab = tab => {
    const { paddingLeft, paddingRight } = getComputedStyle(swatchTabElement);
    const pillRect = swatchTabElement.getBoundingClientRect();
    const { marginLeft, marginRight } = getComputedStyle(tab);
    const tabRect = tab.getBoundingClientRect();
    const tabStart = tabRect.left - parseFloat(marginLeft);
    const tabEnd = tabRect.right + parseFloat(marginRight);
    const visibleStart = pillRect.left + parseFloat(paddingLeft);
    const visibleEnd = pillRect.right - parseFloat(paddingRight);

    let offset = 0;
    if (tabStart < visibleStart) offset = tabStart - visibleStart;
    else if (tabEnd > visibleEnd) offset = tabEnd - visibleEnd;

    if (!offset) return;

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    swatchTabElement.scrollBy({
      left: offset,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  };

  swatchTabs.forEach(tab => {
    const rawData = tab.dataset.products?.trim();
    if (!rawData) return;

    const parsedProducts = rawData
      .split(';')
      .filter(Boolean)
      .map(product => product.split('||'));

    tab.addEventListener('click', () => {
      setTimeout(() => {
        swatchTabs.forEach(t => {
          const isSelected = t === tab;
          t.classList.toggle('selected', isSelected);
          t.setAttribute('aria-pressed', String(isSelected));
        });
      }, 10);

      revealSwatchTab(tab);
      updateSwatchDisplay(parsedProducts);
    });
  });

  const WHEEL_LINE_HEIGHT_PX = 16;

  const getWheelDelta = event => {
    const { deltaX, deltaY, deltaMode } = event;
    const delta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;
    if (deltaMode === WheelEvent.DOM_DELTA_LINE) {
      return delta * WHEEL_LINE_HEIGHT_PX;
    }
    if (deltaMode === WheelEvent.DOM_DELTA_PAGE) {
      return delta * swatchTabElement.clientWidth;
    }
    return delta;
  };

  swatchTabElement.addEventListener(
    'wheel',
    event => {
      if (event.ctrlKey) return;

      const delta = getWheelDelta(event);
      const maxScroll =
        swatchTabElement.scrollWidth - swatchTabElement.clientWidth;
      if (!delta || maxScroll < 1) return;

      const { scrollLeft } = swatchTabElement;
      const canScroll = delta > 0 ? scrollLeft < maxScroll - 1 : scrollLeft > 1;
      if (!canScroll) return;

      event.preventDefault();
      event.stopPropagation();
      swatchTabElement.scrollLeft += delta;
    },
    { passive: false }
  );

  // Floating Swatch Tab Logic
  const swatchSection = document.querySelector('.b2b_swatches');
  if (!swatchSection) return;

  const SECTION_VISIBLE_THRESHOLD = 0.5;
  let lastScrollY = window.scrollY;

  const showTab = () => {
    swatchTabElement.classList.remove('tw-bottom-[-44px]');
    swatchTabElement.style.bottom = '24px';
  };

  const hideTab = () => {
    swatchTabElement.style.bottom = '-44px';
  };

  const getSectionVisibleRatio = () => {
    const sectionRect = swatchSection.getBoundingClientRect();
    const visibleSectionHeight = Math.max(
      0,
      Math.min(window.innerHeight, sectionRect.bottom) -
        Math.max(0, sectionRect.top)
    );
    return visibleSectionHeight / sectionRect.height;
  };

  const isTabOverlappingSection = () => {
    const tabRect = swatchTabElement.getBoundingClientRect();
    const sectionRect = swatchSection.getBoundingClientRect();
    return tabRect.bottom > sectionRect.top && tabRect.top < sectionRect.bottom;
  };

  swatchTabElement.addEventListener('focusin', event => {
    const focusedSwatch = event.target.closest('.swatch-tab-btn');
    if (!focusedSwatch) return;

    showTab();
    requestAnimationFrame(() => revealSwatchTab(focusedSwatch));
  });

  swatchTabElement.addEventListener('focusout', event => {
    if (swatchTabElement.contains(event.relatedTarget)) return;
    if (
      getSectionVisibleRatio() < SECTION_VISIBLE_THRESHOLD &&
      !isTabOverlappingSection()
    ) {
      hideTab();
    }
  });

  const updateTabVisibility = () => {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > lastScrollY;
    lastScrollY = currentScrollY;

    if (swatchTabElement.querySelector(':focus-visible')) {
      showTab();
      return;
    }

    const sectionVisibleRatio = getSectionVisibleRatio();
    const tabOverlapping = isTabOverlappingSection();

    if (isScrollingDown) {
      if (sectionVisibleRatio >= SECTION_VISIBLE_THRESHOLD) showTab();
      if (!tabOverlapping) hideTab();
    } else {
      if (tabOverlapping) showTab();
      if (sectionVisibleRatio <= SECTION_VISIBLE_THRESHOLD) hideTab();
    }
  };

  document.addEventListener('scroll', updateTabVisibility, { passive: true });
  window.addEventListener('resize', updateTabVisibility);
  updateTabVisibility();
});
